import MostRecentPosts from "./most-recent-posts";

export default MostRecentPosts;